import e from "./ghl-ui.es1504.js";
import o from "./ghl-ui.es1454.js";
function n(t) {
  return o(1, arguments), t instanceof Date || e(t) === "object" && Object.prototype.toString.call(t) === "[object Date]";
}
export {
  n as default
};
